import React from 'react'

function GoodSmiley ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 336 336'>
      <path class='cls-1' d='M168,272a72.09,72.09,0,0,0,71.55-64H96.45A72.09,72.09,0,0,0,168,272Z' />
      <circle class='cls-1' cx='104' cy='120' r='8' />
      <path class='cls-1' d='M168,0A168,168,0,1,0,336,168,168,168,0,0,0,168,0ZM104,96a24,24,0,1,1-24,24A24,24,0,0,1,104,96Zm64,192a88.1,88.1,0,0,1-88-88,8,8,0,0,1,8-8H248a8,8,0,0,1,8,8A88.1,88.1,0,0,1,168,288Zm64-144a24,24,0,1,1,24-24A24,24,0,0,1,232,144Z' />
      <circle class='cls-1' cx='232' cy='120' r='8' />
    </svg>
  )
}

GoodSmiley.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default GoodSmiley
